import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import Toast, {PluginOptions} from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueApexCharts from "vue3-apexcharts";
import {VueSelect} from "vue-select";
import "@/assets/css/main.css"
import * as Mathfield from "mathlive";

const globalVars = {
    data() {
        return {
            is_mother: cookies.isKey('is_mother'),
            mother_mode: cookies.isKey('mother_mode'),
            type_one: cookies.isKey('type_1'),
            type_two: cookies.isKey('type_2'),
            id_login: cookies.get('id_login'),
            image_profile: cookies.get('image_profile'),
            
            base_url: 'https://apicra.tavimc.ir/api',
            download_url: 'https://apicra.tavimc.ir',
        }
    },
}
export const base_url = globalVars.data().base_url

createApp(App).component("v-select", VueSelect)
createApp(App).use(store).use(VueApexCharts).use(cookies).use(router).use(Toast, {rtl: true}).use(Mathfield).mixin(globalVars).mount('#app')
